
// import request from '@/utils/request'
import request from '@/utils/request'
import { ouchnCustom } from "@/service"

// 添加学习计划
export function addStudyPlan(data) {
    return request({
        url: ouchnCustom + '/web/plan',
        token: true,
        method: 'post',
        data
    })
}
// 按月份查询学习计划（日历）
export function getStudyPlan(data) {
    return request({
        url: ouchnCustom + '/web/plan/month',
        token: true,
        method: 'get',
        params:data
    })
}
// 按日期查询学习计划时间线
export function getPlanInfo(data) {
    return request({
        url: ouchnCustom + '/web/plan/getPlanInfo',
        token: true,
        method: 'get',
        params:data
    })
}

// 删除学习计划
export function deletePlan(ids) {
    return request({
        url: ouchnCustom + '/web/plan/'+ids,
        token: true,
        method: 'delete',
    })
}
// 更新学习计划
export function updatePlan(data) {
    return request({
        url: ouchnCustom + '/web/plan',
        token: true,
        method: 'put',
        data
    })
}

// 获取用户错题本
export function GetWrongQuestionList(data) {
    return request({
        url: ouchnCustom + '/device/paper/selWrongQuestionList',
        token: true,
        method: 'post',
        data
    })
}
